import {useEffect, useRef} from 'react';

/**
 * Custom hook that returns the previous value of a state or prop.
 *
 * @param {T} value The current value to be tracked.
 * @return {T | undefined} The previous value of the provided input or undefined if no previous value exists.
 */
function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

export default usePrevious;